import axios from "axios";
//Constants

export const createHubSpotContact = async (data) => {
  return await axios.post(
    `${process.env.REACT_APP_MAIN_API}/hubspot/contacts`,
    data
  );
};
